import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useParentAuth } from "@/context/ParentAuthContext";
import { toast } from "sonner";
import { localReturnPath } from "@/lib/api";
import { ArrowRight, User } from "lucide-react";

export default function ParentSignup() {
  const { register } = useParentAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(f.name.trim(), f.email.trim().toLowerCase(), f.password);
      toast.success("Welcome to Naptown Cubers!");
      nav(localReturnPath(next));
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not create account");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16 md:py-24">
      <div className="w-14 h-14 rounded-2xl bg-[#FFBF69]/25 grid place-items-center text-[#B36906]"><User className="w-6 h-6" /></div>
      <h1 className="mt-6 font-display font-black text-4xl tracking-tight">Create parent account</h1>
      <p className="mt-3 text-[#7A7D8C]">Sign up so you can review your cuber's results after the competition.</p>

      <form onSubmit={submit} className="mt-8 bg-white rounded-3xl border border-slate-100 p-6 space-y-4" data-testid="parent-signup-form">
        <Field label="Your name" value={f.name} onChange={(v) => setF({ ...f, name: v })} required tid="signup-name" />
        <Field label="Email" type="email" value={f.email} onChange={(v) => setF({ ...f, email: v })} required tid="signup-email" />
        <Field label="Password (8+ characters)" type="password" value={f.password} onChange={(v) => setF({ ...f, password: v })} required tid="signup-password" />
        <button disabled={busy} type="submit" data-testid="signup-submit" className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#FF9F1C] text-white font-bold shadow-[0_12px_30px_rgb(255,159,28,0.35)] hover:-translate-y-0.5 transition-transform disabled:opacity-60">
          {busy ? "Creating…" : "Create account"} <ArrowRight className="w-4 h-4" />
        </button>
        <p className="text-xs text-[#7A7D8C] text-center">Already have an account? <Link to="/parent/login" className="text-[#FF9F1C] font-semibold">Sign in</Link></p>
      </form>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", required, tid }) {
  return (
    <div>
      <label className="text-xs uppercase tracking-wider font-semibold text-[#7A7D8C]">{label}{required && <span className="text-[#E71D36]"> *</span>}</label>
      <input data-testid={tid} type={type} value={value} required={required} onChange={(e) => onChange(e.target.value)} className="mt-1 w-full rounded-xl border border-slate-200 bg-[#FDFFFC] px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF9F1C] focus:border-[#FF9F1C]" />
    </div>
  );
}
